// extracted by mini-css-extract-plugin
export var columnList = "_f9-0";